import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModalProvier from '../contexts/modal-provider/index.tsx';
import Loading from '../components/common/loading.tsx';

const PublicLayout = () => {
  return (
    <ModalProvier>
      <div className={'flex'}>
        <div className={'w-full'}>
          <Suspense fallback={<Loading />}>
            <Outlet />
          </Suspense>
        </div>
        <ToastContainer position={'top-center'} />
      </div>
    </ModalProvier>
  );
};
export default PublicLayout;
